import React from "react";
import { HiDocumentText, HiCalendar } from "react-icons/hi";
import { FaHandshake } from "react-icons/fa";

const About = () => {
  const trustSignals = [
    { icon: HiCalendar, title: "Established", subtitle: "Since 2020" },
    { icon: HiDocumentText, title: "Registered Company", subtitle: "#3792261" },
    { icon: FaHandshake, title: "Marvel Tech Partner", subtitle: "Solar Energy" },
    { icon: FaHandshake, title: "Stempedia Partner", subtitle: "Education" },
  ];

  return (
    <section id="about" className="py-10 lg:py-14 bg-primary-50">
      <div className="max-w-6xl mx-auto px-4 lg:px-8">
        <div className="grid lg:grid-cols-2 gap-12 lg:gap-16 items-center">
          {/* Image Column */}
          <div className="relative">
            <img
              src="/images/portfolio/about-image.png"
              alt="HexaPi Tech Team"
              className="rounded-2xl shadow-card w-full"
            />
            {/* Experience Badge */}
            <div
              className="absolute -bottom-6 -right-6 bg-white rounded-xl shadow-card-hover
                         p-6 max-w-xs hidden lg:block"
            >
              <h3 className="text-xl font-semibold text-primary-500 mb-2">
                6+ Years Of Working Experience
              </h3>
              <p className="text-sm text-neutral leading-relaxed">
                Your success is ours. If you are looking to move in new
                directions, HexaPi is your "go-to" option.
              </p>
            </div>
          </div>

          {/* Content Column */}
          <div className="flex flex-col">
            <span className="section-subheading">About Us</span>
            <h2 className="section-heading">We Are HexaPi</h2>

            {/* Description - shows after cards on mobile, before on desktop */}
            <p className="order-2 md:order-1 text-neutral text-sm md:text-base mb-6 md:mb-8 leading-relaxed">
              Born from the vision of engineers Samir Rizk and Yasser Haidar in
              2020, HexaPi Tech bridges the gap between hardware and software.
              Our Electronics and Software divisions work hand-in-hand to solve
              complex challenges, giving you a single trusted partner for all
              your technology needs.
            </p>

            {/* Trust Signals Grid - shows first on mobile */}
            <div className="order-1 md:order-2 grid grid-cols-2 lg:grid-cols-4 gap-3 md:gap-4 mb-6 md:mb-0">
              {trustSignals.map((signal, index) => (
                <div
                  key={index}
                  className="text-center p-3 md:p-4 bg-white rounded-xl shadow-card
                             hover:shadow-card-hover transition-all duration-300"
                >
                  <signal.icon className="w-6 h-6 md:w-8 md:h-8 text-primary-500 mx-auto mb-2" />
                  <h4 className="text-xs md:text-sm font-semibold text-neutral-dark">
                    {signal.title}
                  </h4>
                  <p className="text-xs text-neutral mt-0.5">
                    {signal.subtitle}
                  </p>
                </div>
              ))}
            </div>
          </div>
        </div>
      </div>
    </section>
  );
};

export default About;
